import React from "react";
import { Provider } from "react-redux";
import { Outlet } from "react-router";
import configureStore from "./store";
import AppContainer from "../../containers/AppStoreWrapper";
import NotificationsContainer from "../../components/NotificationsContainer/NotificationsContainer";

let store: ReturnType<typeof configureStore>;
function AppStoreWrapper() {
  if (!store) {
    store = configureStore();
  }
  return (
    <Provider store={store}>
      <AppContainer>
        <NotificationsContainer />
        <Outlet />
      </AppContainer>
    </Provider>
  );
}

export default AppStoreWrapper;
